import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { BannerEmailRenderer } from "./email";
import { BannerBlockProps } from "./types";
import { DEFAULT_BANNER } from "./email-panel-image";

export function BannerEditor({ formAPI, ...props }: BannerBlockProps) {
  const { block, shop } = props;

  const item = block.properties?.items?.[0] ?? DEFAULT_BANNER;
  const imageUrl = item.imageId
    ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}`
    : (item.imageUrl ?? DEFAULT_BANNER.imageUrl);

  return (
    <>
      <div>
        <EmailComponentWrapper shop={shop}>
          <BannerEmailRenderer
            formAPI={{
              blockPath: "",
              updateField: () => {},
              getFieldValue: () => {},
              registerImage: () => {},
            }}
            {...props}
            block={{
              ...props.block,
              properties: {
                items: [
                  {
                    ...item,
                    imageId: null,
                    imageUrl,
                  },
                ],
              },
            }}
          />
        </EmailComponentWrapper>
      </div>
    </>
  );
}
